import { render } from "./TelegramArticle.vue?vue&type=template&id=09f7b0af&lang=pug"
import script from "./TelegramArticle.vue?vue&type=script&lang=js"
export * from "./TelegramArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__